import { AppsLink, AppsRoutes, type AppsLinkProps } from '@wellesley/router'
import { FC } from 'react'
import { cn } from '@wellesley/ui'

export type AppListSize = 'sm' | 'lg'

type ItemProps = {
  title?: string
  link?: AppsRoutes
  size: AppListSize
  children: React.ReactNode
  isActive: boolean
  props?: AppsLinkProps['props']
  queryParams?: AppsLinkProps['queryParams']
  onClick?: () => void
}

export const Item: FC<ItemProps> = ({
  link,
  size,
  title,
  children,
  isActive,
  queryParams,
  onClick,
  props,
}) => {
  const content = (
    <div
      className={cn(
        'flex flex-row items-center rounded-m bg-white p-xxs text-gray-900 hover:bg-gray-100',
        {
          'bg-gray-100 text-blue-500': isActive,
        },
      )}
    >
      {children}

      {size === 'lg' && (
        <h6 data-testid="title" className="ml-xs text-base font-medium ">
          {title}
        </h6>
      )}
    </div>
  )

  return (
    <div
      data-testid="item"
      className="group flex flex-row items-center justify-between rounded "
      onClick={onClick}
    >
      {link ? (
        <AppsLink
          to={link}
          props={props}
          queryParams={queryParams}
          className="w-full"
        >
          {content}
        </AppsLink>
      ) : (
        <div className="w-full">{content}</div>
      )}
    </div>
  )
}
